import {getCustomer as fetchCustomerAPI} from "../../services/customer";

export const fetchCustomer = () => {
    return async (dispatch) => {
        dispatch({type: "FETCH_CUSTOMER_START"});
        try {
            const response = await fetchCustomerAPI();
            dispatch({
                type: "FETCH_CUSTOMER_SUCCESS",
                payload: response.data,
            });
        } catch (error) {
            console.error("Failed to fetch customer!", error);
        }
    };
};

export const updateCustomer = (customer) => {
    return async (dispatch) => {
        dispatch({type: "UPDATE_CUSTOMER_START"});
        try {
            const response = await fetchCustomerAPI(customer);
            dispatch({
                type: "UPDATE_CUSTOMER_SUCCESS",
                payload: response.data,
            });
        } catch (error) {
            console.error("Failed to update customer!", error);
        }
    };
}
